import {handleActions, createAction} from 'redux-actions';
import {createThunkActionCreator} from 'utils/redux/createThunkActionCreator';
import * as thunkActionConstants from 'utils/redux/thunkActionConstants';
import * as purchasesApi from 'services/api/purchases';

const reducerMap = {};

const PURCHASES_RESET = 'PURCHASES/PURCHASES_RESET';
export const purchasesResetAction = createAction(PURCHASES_RESET);
reducerMap[PURCHASES_RESET] = (state, action) => {
  return {
    ...action
  };
};

/**
 * @function purchasesFetch
 * @param {bool} active
 * @return {Function}
 */
export const PURCHASES_FETCH = 'PURCHASES/PURCHASES_FETCH';
export const purchasesFetch = createThunkActionCreator(PURCHASES_FETCH, (active) => {
  return purchasesApi.getPurchases(active);
});
reducerMap[PURCHASES_FETCH] = (state, action) => {
  const {payload, args, ...rest} = action;
  if (action.status === thunkActionConstants.ACTION_STATUS_PENDING) {
    const active = args && args.length ? args[0] : false;
    return {...rest, active};
  }

  return {...state, ...rest, purchases: payload};
};

/**
 * @function purchaseFetchAction
 * @param {string} externalId
 * @return {Function}
 */
export const PURCHASE_FETCH = 'PURCHASES/PURCHASE_FETCH';
export const purchaseFetchAction = createThunkActionCreator(PURCHASE_FETCH, (externalId) => {
  return purchasesApi.getPurchaseByExternalId(externalId);
});
reducerMap[PURCHASE_FETCH] = (state, action) => {
  const {payload, ...rest} = action;
  let purchases;

  switch (rest.status) {
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      purchases = state.purchases.map((purchase) => {
        return purchase.externalId === payload.externalId ? payload : purchase;
      });
      return {...state, ...action, purchases};
    case thunkActionConstants.ACTION_STATUS_PENDING:
    case thunkActionConstants.ACTION_STATUS_FAIL:
    default:
      return {...state, ...action};
  }
};

export const PURCHASE_DOCUMENT_FETCH = 'PURCHASE/DOCUMENT_FETCH';
export const purchaseDocumentFetch = createThunkActionCreator(PURCHASE_DOCUMENT_FETCH, (purchaseId, notification, documentType) => {
  return purchasesApi.getDocumentForPurchase(purchaseId, notification, documentType);
});

reducerMap[PURCHASE_DOCUMENT_FETCH] = (state, action) => {
  const {payload, ...rest} = action;
  let externalId;

  switch (rest.status) {
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {...state, ...rest, document: {...state.document, ...rest, ...payload}};

    case thunkActionConstants.ACTION_STATUS_PENDING:
      externalId = action.args[0];
      return {...state, document: {...rest, externalId}, action};

    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {...state, document: {...state.document, ...rest, error: action.error}, action};
  }
};

const PURCHASES_UPDATE_DEBIT_CARD_RESET = 'PURCHASES/UPDATE_DEBIT_CARD_RESET';
export const purchasesUpdateDebitCardResetAction = createAction(PURCHASES_UPDATE_DEBIT_CARD_RESET);
reducerMap[PURCHASES_UPDATE_DEBIT_CARD_RESET] = (state, action) => {
  return {
    ...state, ...action, updateDebitCard: {}
  };
};

export const PURCHASE_UPDATE_DEBIT_CARD = 'PURCHASE/UPDATE_DEBIT_CARD';
export const purchaseUpdateDebitCardAction = createThunkActionCreator(PURCHASE_UPDATE_DEBIT_CARD, (externalId, cardNumber, expirationMonth, expirationYear, cvv) => {
  return purchasesApi.updatePurchaseDebitCard(externalId, cardNumber, expirationMonth, expirationYear, cvv);
});

reducerMap[PURCHASE_UPDATE_DEBIT_CARD] = (state, action) => {
  const {payload, ...rest} = action;
  let externalId, cardNumber, expirationMonth, expirationYear;

  switch (rest.status) {
    case thunkActionConstants.ACTION_STATUS_SUCCESS: {
      const nextPurchases = state.purchases.map(purchase=>{
          if (purchase.externalId === state.externalId) {
            return {updateDebitCard: state.updateDebitCard, ...purchase}
          }
          return purchase
      })
      return {...state, ...rest, purchases: nextPurchases, updateDebitCard: {...state.updateDebitCard, ...payload}};
    }

    case thunkActionConstants.ACTION_STATUS_PENDING:
      [externalId, cardNumber, expirationMonth, expirationYear] = action.args || [];
      return {...state, ...action, updateDebitCard: {externalId, cardNumber, expirationMonth, expirationYear}};

    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {...state, ...action, updateDebitCard: {...state.updateDebitCard, ...rest, error: action.error}};
  }
};

const PURCHASE_PAY_LATE_RESET = 'PURCHASES/PAY_LATE_RESET';
export const purchasePayLateReset = createAction(PURCHASE_PAY_LATE_RESET);
reducerMap[PURCHASE_PAY_LATE_RESET] = (state, action) => {
  return {
    ...state, ...action, payLate: {}
  };
};

export const PURCHASE_PAY_LATE = 'PURCHASE/PAY_LATE';
export const purchasePayLate = createThunkActionCreator(PURCHASE_PAY_LATE, (externalId, amount = null) => {
  return purchasesApi.payLate(externalId, amount);
});

reducerMap[PURCHASE_PAY_LATE] = (state, action) => {
  const {payload, ...rest} = action;
  let externalId, amount;

  switch (rest.status) {
    case thunkActionConstants.ACTION_STATUS_SUCCESS:
      return {...state, ...rest, payLate: {...state.payLate, ...payload}};

    case thunkActionConstants.ACTION_STATUS_PENDING:
      [externalId, amount] = action.args || [];
      return {...state, ...action, payLate: {externalId, amount}};

    case thunkActionConstants.ACTION_STATUS_FAIL:
      return {...state, ...action, payLate: {...state.payLate, ...rest, error: action.error}};
  }
};


const PURCHASE_CARD_TAB_CHANGE = 'PURCHASES/PURCHASE_CARDS_TAB_CHANGE';
export const purchaseCardTabChangeAction = createAction(PURCHASE_CARD_TAB_CHANGE, (externalId, tabIndex) => ({externalId, tabIndex}));
reducerMap[PURCHASE_CARD_TAB_CHANGE] = (state, action) => {
  const {payload, ...rest} = action;
  return {
    ...state, ...rest, ...payload
  };
};

export const reducer = handleActions(reducerMap, {
  document: {},
  updateDebitCard: {},
  payLate: {}
});



// WEBPACK FOOTER //
// ./src/purchases/redux.js